export interface ProductRelease {
  id: string;
  title: string;
  summary: string;
  publishedAt: string;
  published: boolean;
  audience?: 'startup' | 'vc';
  highlights: { title: string; description: string }[];
}

export const productReleases: ProductRelease[] = [
  {
    id: 'ui-refresh-2026-09',
    title: 'A cleaner, simpler Vein',
    summary: 'Same Vein, cleaner look. Everything you use is still here.',
    publishedAt: '2026-09-22T00:00:00Z',
    published: true,
    highlights: [
      { title: 'Reports read like reports', description: 'Clear sections, a real metrics table, and a matching PDF.' },
      { title: 'Edit blocks in place', description: 'Click a block to edit it. Add new ones from the right.' },
      { title: 'Simpler requests', description: 'Topics with a note, any due date, custom repeats.' },
      { title: 'Choose what a report covers', description: 'As of today, a quarter, or a month.' },
    ],
  },
  {
    id: 'updates-and-feedback-v1',
    title: 'Share feedback whenever you need',
    summary: 'Send comments, ideas, and issues with Leave feedback in What’s new, which you can reopen anytime from the page footer.',
    publishedAt: '2026-09-14T00:00:00Z',
    published: true,
    highlights: [],
  },
];

export function visibleReleases(releases: ProductRelease[], mode: string, now = Date.now()) {
  return releases.filter(release => release.published &&
    Date.parse(release.publishedAt) <= now && (!release.audience || release.audience === mode))
    .sort((a, b) => Date.parse(b.publishedAt) - Date.parse(a.publishedAt));
}

export function feedbackPage(pathname: string): string {
  const section = pathname.split('/')[2] || 'dashboard';
  const names: Record<string, string> = {
    dashboard: 'Dashboard', portfolio: 'Portfolio', companies: 'Company details',
    reporting: 'Reporting', applications: 'Applications', settings: 'Settings',
    connections: 'Connections', investors: 'Investors', vault: 'Vault', 'data-access': 'Data access',
  };
  return names[section] || 'Vein';
}
